import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import dompurify from 'dompurify';

const EmlViewer = props => {
  const { emlText } = props;
  const [headers, setHeaders] = useState();
  const [attachments, setAttachments] = useState([]);
  const [body, setBody] = useState();

  const parseHeaders = useCallback(text => {
    const headers = {};
    text.split('\r\n').forEach(line => {
      const [key, ...value] = line.split(':');
      headers[key.toLocaleLowerCase()] = value.join(':');
    });
    setHeaders(headers);
  }, []);

  const parseBody = useCallback(text => {
    const arr = text.split('\r\n');
    arr.shift();
    const html = arr.join('\r\n');
    setBody(dompurify.sanitize(html));
  }, []);

  const parseAttachment = useCallback(text => {
    const [headers, body] = text.split('\r\n\r\n');
    const contentType = headers.split('\r\n')[0].split(':')[1].trim();
    const [, filename] = headers.match(/filename="([^"]+)"/);

    setAttachments(prev => [...prev, { filename, body, contentType }]);
  }, []);

  const parseEml = useCallback(
    text => {
      setAttachments([]);
      const index = text.indexOf('boundary="');
      const boundary = text.substr(index + 10, 41);
      const sections = text.split('--' + boundary);

      //remove trailing end of file boundary
      sections.pop();

      sections.forEach(section => {
        const text = section.trim();

        if (text.includes(boundary)) parseHeaders(text);
        else if (text.includes('Content-Type: text/html;')) parseBody(text);
        else parseAttachment(text);
      });
    },
    [setAttachments, parseAttachment, parseHeaders, parseBody]
  );

  useEffect(() => {
    if (emlText) parseEml(emlText);
  }, [emlText, parseEml]);

  const downloadAttachment = (event, att) => {
    event?.preventDefault();
    const { filename, contentType, body } = att;
    const decoded = atob(body);
    let len = decoded.length;
    const bytes = [];
    while (len--) bytes[len] = decoded.charCodeAt(len);

    const blob = new Blob([new Uint8Array(bytes)], { type: contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  };

  return (
    <div>
      {headers && body ? (
        <>
          <div
            className="row"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
            }}
          >
            <div>
              <b>From: </b>
              <span>{headers.from}</span>
            </div>
            <div>
              <b>To: </b>
              <span>
                {headers.to
                  .split(', ')
                  .map(str => str.replaceAll(/<|>/g, ''))
                  .join(', ')}
              </span>
            </div>
            <div>
              <b>Subject: </b>
              <span>{headers.subject}</span>
            </div>
            {headers.cc ? (
              <div>
                <b>Cc: </b>
                <span>
                  {' '}
                  {headers.cc
                    .split(', ')
                    .map(str => str.substr(2, str.length - 3))
                    .join(', ')}
                </span>
              </div>
            ) : null}
            {headers.bcc ? (
              <div>
                <b>Bcc: </b>
                <span>
                  {' '}
                  {headers.bcc
                    .split(', ')
                    .map(str => str.substr(2, str.length - 3))
                    .join(', ')}
                </span>
              </div>
            ) : null}
            <div>
              <b>Timestamp: </b>
              <span>{moment(headers.date).format('MM/DD/YYYY h:mm:ss A')}</span>
            </div>
          </div>
          {attachments && attachments.length ? (
            <>
              <div className="divider" />
              <div className="row" style={{ marginTop: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {attachments.map((att, index) => (
                    <a
                      key={index}
                      href="/"
                      onClick={event => downloadAttachment(event, att)}
                    >
                      {att.filename}
                    </a>
                  ))}
                </div>
              </div>
            </>
          ) : null}
          <div className="divider" />
          <div className="row" style={{ marginTop: '40px' }}>
            <div dangerouslySetInnerHTML={{ __html: body }} />
          </div>
        </>
      ) : (
        <div className="progress blue">
          <div className="indeterminate" />
        </div>
      )}
    </div>
  );
};

export default EmlViewer;
